export default __webpack_public_path__ + "static/media/DAI.253a4d84.svg";